import { createSlice } from "@reduxjs/toolkit";
import {
  addFeedBack,
  editFeedback,
  getFeedback,
  getFeedbackList,
} from "../services/feedback-services";

const initialState = {
  feedbacks: [],
  feedback: null,
  pagination: null,
  error: [],
  loading: false,
  responseMessage: null,
  success: false,
  successMessage: null,
  deleteResponse: false,
  errorMessage: null,
};

export const feedbackSlice = createSlice({
  name: "state",
  initialState,
  reducers: {
    resetError(state) {
      state.errorMessage = null;
    },

    resetSuccess(state) {
      state.successMessage = null;
    },

    resetState(state) {
      state.success = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFeedbackList.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFeedbackList.fulfilled, (state, action) => {
        state.feedbacks = action.payload.data.items;
        state.pagination = action.payload.data.item;
        state.currentPage = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getFeedbackList.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getFeedback.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getFeedback.fulfilled, (state, action) => {
        state.feedbacks = action.payload.data.item;
        state.pagination = action.payload.data.item;
        state.loading = false;
      })
      .addCase(getFeedback.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(addFeedBack.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(addFeedBack.fulfilled, (state, action) => {
        state.feedbacks = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(addFeedBack.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      })
      .addCase(editFeedback.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editFeedback.fulfilled, (state, action) => {
        state.feedbacks = action.payload;
        state.successMessage = action.payload.message;
        state.loading = false;
        state.success = true;
      })
      .addCase(editFeedback.rejected, (state, action) => {
        state.loading = false;
        if (action.payload) {
          state.errorMessage = action.payload;
        } else {
          state.errorMessage = "Something went wrong";
        }
      });
  },
});
export const { resetSuccess, resetState, resetError } = feedbackSlice.actions;
export const error = (state) => state.error;
export const loading = (state) => state.loading;
export const deleteResponse = (state) => state.deleteResponse;
export default feedbackSlice.reducer;
